import erc20Abi from "./abis/erc20.json";
import ownableAbi from "./abis/ownable.json";
import concordAbi from "./abis/concord.json";

const abis = {
  erc20: erc20Abi,
  ownable: ownableAbi,
  concord: concordAbi,
};

export default abis;
